import { render, staticRenderFns } from "./FilmImageView.vue?vue&type=template&id=72a717b4&scoped=true&"
import script from "./FilmImageView.vue?vue&type=script&lang=js&"
export * from "./FilmImageView.vue?vue&type=script&lang=js&"
import style0 from "./FilmImageView.vue?vue&type=style&index=0&id=72a717b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a717b4",
  null
  
)

export default component.exports